import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { TextBox, Button as TextBoxButton } from 'devextreme-react/text-box';
import { LoadPanel } from 'devextreme-react/load-panel';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator, { RequiredRule, EmailRule, AsyncRule, StringLengthRule, PatternRule, CompareRule, CustomRule } from 'devextreme-react/validator';
import { CheckBox, SelectBox, TextArea, NumberBox, DateBox } from 'devextreme-react';
import Button from 'devextreme-react/button';
import { useNavigate } from 'react-router-dom';
import { useGoogleLogin } from '@react-oauth/google';
import KhongDau from 'khong-dau';
import { parsePhoneNumberFromString, getCountryCallingCode, isValidPhoneNumber, isSupportedCountry, getExampleNumber } from 'libphonenumber-js';
import phoneExamples from 'libphonenumber-js/examples.mobile.json';
// import CheckBox from 'devextreme-react/check-box';
import './index.scss';
import { Link } from 'react-router-dom';
import cs from '../../utils/const.js';
import AntString from '../../utils/AntString.js';
import AntBusiness from '../../utils/AntBusiness';
import AntAuth from '../../utils/AntAuth';
import AntLocalization from '../../utils/AntLocalization';
import AntErrorPanel from '../AntErrorPanel';
import AntTitlePanel from '../AntTitlePanel';
import AntDescPanel from '../AntDescPanel';
import AntCardLayout from '../AntCardLayout';
import AntText from '../AntText';

import { AntGlobal, AntSessionContext } from '../../utils/AntContext';

import currencies from '../../data/currencies.json';

// import GoogleLogin from './GoogleLogin';
import GoogleLoginButton from './GoogleLoginButton';

export default function (props) {
    const appGlobal = AntGlobal();
    const navigate = useNavigate();
    const hasBusShortCode = Boolean(cs.Business_Short_Code);
    const [currentStage, setCurrentStage] = useState('Step1');
    const [currentToken, setCurrentToken] = useState('');
    const [subIndustry, _setSubIndustry] = useState('');
    const setSubIndustry = useCallback((val) => {
        _setSubIndustry(val);
        if (props.onSubIndustryChanged) props.onSubIndustryChanged(val);
    }, [props.onSubIndustryChanged]);

    useEffect(() => {
        if (props.onSubIndustryChanged) props.onSubIndustryChanged(subIndustry);
        return () => { if (props.onSubIndustryChanged) props.onSubIndustryChanged(null); };
    }, []);
    const [baseCurrency, setBaseCurrency] = useState('VND');
    const [baseCountry, setBaseCountry] = useState('');
    const [baseLanguage, setBaseLanguage] = useState('');
    const [baseTimezone, setBaseTimezone] = useState('');
    const [countryList, setCountryList] = useState([]);
    const [isCountryLocked, setIsCountryLocked] = useState(false);
    // Đa số quốc gia chỉ 1 đồng tiền → ẩn ô chọn, tự gán. Vài nước lưu hành song song nhiều
    // đồng tiền (vd Campuchia KHR+USD) → hiện dropdown nhưng CHỈ trong danh sách này, không
    // phải toàn bộ danh mục tiền tệ. length !== 1 để mặc định (chưa có data) vẫn hiện như cũ.
    const [allowedCurrencies, setAllowedCurrencies] = useState([]);
    const [usePhoneNumber, setUsePhoneNumber] = useState(false);
    const [busName, setBusName] = useState('');
    const [busShortCode, setBusShortCode] = useState('');

    const [step1Processable, setStep1Processable] = useState(false);
    const [step2Processable, setStep2Processable] = useState(false);

    const [registerType, setRegisterType] = useState('WithPhoneAndEmail'); // 'WithPhoneAndEmail' | 'GoogleAccount'

    const [message, setMessage] = useState('');

    const [ownerFullName, setOwnerFullName] = useState('');
    const [ownerPhone, setOwnerPhone] = useState('');
    const [ownerEmail, setOwnerEmail] = useState('');
    const [ownerOTP, setOwnerOTP] = useState('');

    const [errorText, setErrorText] = useState('');
    const [logging, setLogging] = useState(false);

    const subIndustries = [
        {
            code: 'Commodity-GroceryStore',
            name: { vi: 'Hàng hóa: Tạp hóa', en: 'Commodity: Groceries', fr: 'Commerce : Épicerie', es: 'Comercio: Abarrotes', id: 'Komoditas: Toko Kelontong', ja: '商品: 食料品店', zh: '商品：杂货店', ko: '상품: 식료품점', hi: 'कमोडिटी: किराना', ar: 'سلع: بقالة' }
        },
        {
            code: 'Commodity-Supermarket',
            name: { vi: 'Hàng hóa: Siêu thị', en: 'Commodity: Supermarket', fr: 'Commerce : Supermarché', es: 'Comercio: Supermercado', id: 'Komoditas: Supermarket', ja: '商品: スーパーマーケット', zh: '商品：超市', ko: '상품: 슈퍼마켓', hi: 'कमोडिटी: सुपरमार्केट', ar: 'سلع: سوبرماركت' }
        },
        {
            code: 'Commodity-ConvenienceStore',
            name: { vi: 'Hàng hóa: Cửa hàng tiện lợi', en: 'Commodity: Convenience Store', fr: 'Commerce : Supérette', es: 'Comercio: Tienda de conveniencia', id: 'Komoditas: Toko Serba Ada', ja: '商品: コンビニエンスストア', zh: '商品：便利店', ko: '상품: 편의점', hi: 'कमोडिटी: सुविधा स्टोर', ar: 'سلع: متجر صغير' }
        },
        {
            code: 'Commodity-Fashion',
            name: { vi: 'Hàng hóa: Thời trang', en: 'Commodity: Fashion Retail', fr: 'Commerce : Mode', es: 'Comercio: Moda', id: 'Komoditas: Fashion', ja: '商品: ファッション', zh: '商品：时装零售', ko: '상품: 패션', hi: 'कमोडिटी: फैशन', ar: 'سلع: أزياء' }
        },
        {
            code: 'Commodity-Electronic',
            name: { vi: 'Hàng hóa: Điện máy', en: 'Commodity: Electronics', fr: 'Commerce : Électronique', es: 'Comercio: Electrónica', id: 'Komoditas: Elektronik', ja: '商品: 家電', zh: '商品：电器', ko: '상품: 전자제품', hi: 'कमोडिटी: इलेक्ट्रॉनिक्स', ar: 'سلع: إلكترونيات' }
        },
        {
            code: 'Commodity-HighTech',
            name: { vi: 'Hàng hóa: Công nghệ', en: 'Commodity: High-Tech Products', fr: 'Commerce : Haute technologie', es: 'Comercio: Alta tecnología', id: 'Komoditas: Teknologi Tinggi', ja: '商品: ハイテク製品', zh: '商品：高科技产品', ko: '상품: 하이테크', hi: 'कमोडिटी: हाई-टेक', ar: 'سلع: تقنية عالية' }
        },
        {
            code: 'Commodity-Pharmacy',
            name: { vi: 'Hàng hóa: Quầy thuốc', en: 'Commodity: Pharmacy', fr: 'Commerce : Pharmacie', es: 'Comercio: Farmacia', id: 'Komoditas: Apotek', ja: '商品: 薬局', zh: '商品：药店', ko: '상품: 약국', hi: 'कमोडिटी: फार्मेसी', ar: 'سلع: صيدلية' }
        },
        {
            code: 'Commodity-Furniture',
            name: { vi: 'Hàng hóa: Nội thất', en: 'Commodity: Furniture', fr: 'Commerce : Mobilier', es: 'Comercio: Muebles', id: 'Komoditas: Furnitur', ja: '商品: 家具', zh: '商品：家具', ko: '상품: 가구', hi: 'कमोडिटी: फर्नीचर', ar: 'سلع: أثاث' }
        },
        {
            code: 'Commodity-HouseWare',
            name: { vi: 'Hàng hóa: Đồ gia dụng', en: 'Commodity: Housewares', fr: 'Commerce : Articles ménagers', es: 'Comercio: Artículos del hogar', id: 'Komoditas: Peralatan Rumah', ja: '商品: 日用品', zh: '商品：家居用品', ko: '상품: 생활용품', hi: 'कमोडिटी: घरेलू सामान', ar: 'سلع: أدوات منزلية' }
        },
        // {
        //   code: 'Commodity-Manufacturer',
        //   name: { vi: 'Hàng hóa: Nhà máy sản xuất', en: 'Commodity: Manufacturing Factory', fr: 'Commerce : Usine de fabrication', es: 'Comercio: Fábrica', id: 'Komoditas: Pabrik', ja: '商品: 製造工場', zh: '商品：制造工厂', ko: '상품: 제조 공장', hi: 'कमोडिटी: कारखाना', ar: 'سلع: مصنع' }
        // },
        {
            code: 'Commodity-Distributor',
            name: { vi: 'Hàng hóa: Phân phối hàng hóa', en: 'Commodity: Distribution', fr: 'Commerce : Distribution', es: 'Comercio: Distribución', id: 'Komoditas: Distribusi', ja: '商品: 流通', zh: '商品：分销', ko: '상품: 유통', hi: 'कमोडिटी: वितरण', ar: 'سلع: توزيع' }
        },
        {
            code: 'Commodity-WholeSale',
            name: { vi: 'Hàng hóa: Bán sỉ hàng hóa', en: 'Commodity: Wholesale', fr: 'Commerce : Vente en gros', es: 'Comercio: Venta al por mayor', id: 'Komoditas: Grosir', ja: '商品: 卸売', zh: '商品：批发', ko: '상품: 도매', hi: 'कमोडिटी: थोक', ar: 'سلع: بيع بالجملة' }
        },
        {
            code: 'Commodity-Online',
            name: { vi: 'Hàng hóa: Bán hàng Online', en: 'Commodity: Online Retail', fr: 'Commerce : Vente en ligne', es: 'Comercio: Venta en línea', id: 'Komoditas: Penjualan Online', ja: '商品: オンライン販売', zh: '商品：线上零售', ko: '상품: 온라인 판매', hi: 'कमोडिटी: ऑनलाइन रिटेल', ar: 'سلع: بيع إلكتروني' }
        },
        {
            code: 'Commodity-Other',
            name: { vi: 'Hàng hóa: Bán hàng hóa khác', en: 'Commodity: Other Goods', fr: 'Commerce : Autres produits', es: 'Comercio: Otros productos', id: 'Komoditas: Barang Lainnya', ja: '商品: その他', zh: '商品：其他商品', ko: '상품: 기타', hi: 'कमोडिटी: अन्य सामान', ar: 'سلع: منتجات أخرى' }
        },

        {
            code: 'Food-Restaurant',
            name: { vi: 'Ăn uống: Nhà hàng', en: 'Food & Beverage: Restaurant', fr: 'Restauration : Restaurant', es: 'Alimentos : Restaurante', id: 'Makanan : Restoran', ja: '飲食 : レストラン', zh: '餐饮：餐厅', ko: '식음료 : 레스토랑', hi: 'खाद्य : रेस्तरां', ar: 'أغذية : مطعم' }
        },
        {
            code: 'Food-Eatery-AtTable',
            name: { vi: 'Ăn uống: Quán ăn (bán tại bàn)', en: 'Food & Beverage: Eatery (Table Service)', fr: 'Restauration : Service à table', es: 'Alimentos : Servicio en mesa', id: 'Makanan : Makan di Tempat', ja: '飲食 : テーブルサービス', zh: '餐饮：堂食', ko: '식음료 : 테이블 서비스', hi: 'खाद्य : टेबल सर्विस', ar: 'أغذية : خدمة الطاولة' }
        },
        {
            code: 'Food-Eatery-TakeAway',
            name: { vi: 'Ăn uống: Quán ăn (mang về)', en: 'Food & Beverage: Eatery (Takeaway)', fr: 'Restauration : Vente à emporter', es: 'Alimentos : Para llevar', id: 'Makanan : Bawa Pulang', ja: '飲食 : テイクアウト', zh: '餐饮：外带', ko: '식음료 : 포장', hi: 'खाद्य : टेकअवे', ar: 'أغذية : وجبات سفري' }
        },
        {
            code: 'Food-Eatery-AtCounter',
            name: { vi: 'Ăn uống: Quán ăn (bán tại quầy)', en: 'Food & Beverage: Eatery (Counter Service)', fr: 'Restauration : Service au comptoir', es: 'Alimentos : Servicio en mostrador', id: 'Makanan : Pesan di Kasir', ja: '飲食 : カウンターサービス', zh: '餐饮：柜台点餐', ko: '식음료 : 카운터 서비스', hi: 'खाद्य : काउंटर सर्विस', ar: 'أغذية : خدمة الكاونتر' }
        },
        {
            code: 'Food-CoffeeShop-AtTable',
            name: { vi: 'Ăn uống: Quán cà phê (bán tại bàn)', en: 'Coffee Shop: Table Service', fr: 'Café : Service à table', es: 'Cafetería : Servicio en mesa', id: 'Kedai Kopi : Makan di Tempat', ja: 'カフェ : テーブルサービス', zh: '咖啡店：堂饮', ko: '카페 : 테이블 서비스', hi: 'कॉफ़ी शॉप : टेबल सर्विस', ar: 'مقهى : خدمة الطاولة' }
        },
        {
            code: 'Food-CoffeeShop-TakeAway',
            name: { vi: 'Ăn uống: Quán cà phê (mang về)', en: 'Coffee Shop: Takeaway', fr: 'Café : Vente à emporter', es: 'Cafetería : Para llevar', id: 'Kedai Kopi : Bawa Pulang', ja: 'カフェ : テイクアウト', zh: '咖啡店：外带', ko: '카페 : 포장', hi: 'कॉफ़ी शॉप : टेकअवे', ar: 'مقهى : وجبات سفري' }
        },
        {
            code: 'Food-CoffeeShop-AtCounter',
            name: { vi: 'Ăn uống: Quán cà phê (bán tại quầy)', en: 'Coffee Shop: Counter Service', fr: 'Café : Service au comptoir', es: 'Cafetería : Servicio en mostrador', id: 'Kedai Kopi : Pesan di Kasir', ja: 'カフェ : カウンターサービス', zh: '咖啡店：柜台点单', ko: '카페 : 카운터 서비스', hi: 'कॉफ़ी शॉप : काउंटर सर्विस', ar: 'مقهى : خدمة الكاونتر' }
        },

        {
            code: 'FixedService-Barbershop',
            name: { vi: 'Dịch vụ: Cắt tóc nam', en: 'Service: Barbershop', fr: 'Service : Barbier', es: 'Servicio : Barbería', id: 'Layanan : Barbershop', ja: 'サービス : 理髪店', zh: '服务：理发店', ko: '서비스 : 이발소', hi: 'सेवा : नाई की दुकान', ar: 'خدمات : حلاقة' }
        },
        {
            code: 'FixedService-BeautySalon',
            name: { vi: 'Dịch vụ: Chăm sóc làm đẹp', en: 'Service: Beauty Salon', fr: 'Service : Salon de beauté', es: 'Servicio : Salón de belleza', id: 'Layanan : Salon Kecantikan', ja: 'サービス : 美容室', zh: '服务：美容院', ko: '서비스 : 뷰티 살롱', hi: 'सेवा : ब्यूटी सैलून', ar: 'خدمات : صالون تجميل' }
        },
        // {
        //   code: 'FixedService-Petshop',
        //   name: { vi: 'Dịch vụ: Chăm sóc thú cưng', en: 'Service: Pet Care', fr: 'Service : Soins animaux', es: 'Servicio : Mascotas', id: 'Layanan : Perawatan Hewan', ja: 'サービス : ペットケア', zh: '服务：宠物护理', ko: '서비스 : 반려동물 케어', hi: 'सेवा : पालतू देखभाल', ar: 'خدمات : رعاية الحيوانات' }
        // },
        {
            code: 'FixedService-Clinic',
            name: { vi: 'Dịch vụ: Phòng khám', en: 'Service: Clinic', fr: 'Service : Clinique', es: 'Servicio : Clínica', id: 'Layanan : Klinik', ja: 'サービス : クリニック', zh: '服务：诊所', ko: '서비스 : 클리닉', hi: 'सेवा : क्लिनिक', ar: 'خدمات : عيادة' }
        },
        // {
        //   code: 'FixedService-Hospital',
        //   name: { vi: 'Dịch vụ: Bệnh viện', en: 'Service: Hospital', fr: 'Service : Hôpital', es: 'Servicio : Hospital', id: 'Layanan : Rumah Sakit', ja: 'サービス : 病院', zh: '服务：医院', ko: '서비스 : 병원', hi: 'सेवा : अस्पताल', ar: 'خدمات : مستشفى' }
        // },
        {
            code: 'FixedService-Gym',
            name: { vi: 'Dịch vụ: Phòng Gym', en: 'Service: Gym', fr: 'Service : Salle de sport', es: 'Servicio : Gimnasio', id: 'Layanan : Gym', ja: 'サービス : ジム', zh: '服务：健身房', ko: '서비스 : 헬스장', hi: 'सेवा : जिम / फिटनेस', ar: 'خدمات : صالة رياضية' }
        },
        // {
        //   code: 'FixedService-Ticketing',
        //   name: { vi: 'Dịch vụ: Bán vé', en: 'Service: Ticketing', fr: 'Service : Billetterie', es: 'Servicio : Entradas', id: 'Layanan : Tiket', ja: 'サービス : チケット', zh: '服务：票务', ko: '서비스 : 티켓 판매', hi: 'सेवा : टिकट बिक्री', ar: 'خدمات : بيع التذاكر' }
        // },
        {
            code: 'FixedService-Other',
            name: { vi: 'Dịch vụ theo lượt khác', en: 'Other session services', fr: 'Autres services', es: 'Otros servicios', id: 'Layanan : Layanan per Sesi Lainnya', ja: 'サービス : その他セッション型', zh: '服务：其他按次服务', ko: '서비스 : 기타 세션 서비스', hi: 'सेवा : अन्य सत्र-आधारित', ar: 'خدمات : خدمات أخرى بالجلسة' }
        },

        {
            code: 'ExpandableService-Karaoke',
            name: { vi: 'Cho thuê: Quán Karaoke', en: 'Rental: Karaoke Lounge', fr: 'Location : Karaoké', es: 'Alquiler : Karaoke', id: 'Sewa : Karaoke', ja: 'レンタル : カラオケ', zh: '租赁：卡拉OK', ko: '대여 : 노래방', hi: 'किराया : कराओके', ar: 'تأجير : كاريوكي' }
        },
        {
            code: 'ExpandableService-Billiards',
            name: { vi: 'Cho thuê: Quán Bida', en: 'Rental: Billiards Club', fr: 'Location : Billard', es: 'Alquiler : Billar', id: 'Sewa : Biliar', ja: 'レンタル : ビリヤード', zh: '租赁：台球', ko: '대여 : 당구장', hi: 'किराया : बिलियर्ड्स', ar: 'تأجير : بلياردو' }
        },
        {
            code: 'ExpandableService-Sport',
            name: { vi: 'Cho thuê: Sân thể thao', en: 'Rental: Sports Field', fr: 'Location : Terrain de sport', es: 'Alquiler : Cancha deportiva', id: 'Sewa : Lapangan Olahraga', ja: 'レンタル : スポーツ場', zh: '租赁：运动场', ko: '대여 : 스포츠 경기장', hi: 'किराया : खेल मैदान', ar: 'تأجير : ملعب رياضي' }
        },
        // {
        //   code: 'ExpandableService-Other',
        //   name: { vi: 'Cho thuê: Theo giờ khác', en: 'Rental: Other Hourly Services', fr: 'Location : Autres à l\'heure', es: 'Alquiler : Otros por hora', id: 'Sewa : Per Jam Lainnya', ja: 'レンタル : その他時間制', zh: '租赁：其他按时', ko: '대여 : 기타 시간제', hi: 'किराया : अन्य प्रति घंटा', ar: 'تأجير : أخرى بالساعة' }
        // },
        {
            code: 'ExpandableService-Rental-Hotel',
            name: { vi: 'Cho thuê: Khách sạn', en: 'Rental: Hotel', fr: 'Location : Hôtel', es: 'Alquiler : Hotel', id: 'Sewa : Hotel', ja: 'レンタル : ホテル', zh: '租赁：酒店', ko: '대여 : 호텔', hi: 'किराया : होटल', ar: 'تأجير : فندق' }
        }
        // {
        //   code: 'ExpandableService-Rental-Vehicle',
        //   name: { vi: 'Cho thuê: Cho thuê xe', en: 'Rental: Vehicle Rental', fr: 'Location : Véhicules', es: 'Alquiler : Vehículos', id: 'Sewa : Kendaraan', ja: 'レンタル : 車両', zh: '租赁：车辆', ko: '대여 : 차량', hi: 'किराया : वाहन', ar: 'تأجير : مركبات' }
        // },
        // {
        //   code: 'ExpandableService-Rental-House',
        //   name: { vi: 'Cho thuê: Cho thuê nhà', en: 'Rental: House Rental', fr: 'Location : Logements', es: 'Alquiler : Viviendas', id: 'Sewa : Rumah', ja: 'レンタル : 住宅', zh: '租赁：房屋', ko: '대여 : 주택', hi: 'किराया : मकान', ar: 'تأجير : منازل' }
        // },

        // {
        //   code: 'Projection-Trading',
        //   name: { vi: 'Quản lý dự án thương mại', en: 'Project Management: Commercial Trading', fr: 'Gestion de projet : Commerce', es: 'Gestión de proyectos: Comercio', id: 'Manajemen Proyek: Perdagangan', ja: 'プロジェクト管理: 商業', zh: '项目管理：商贸', ko: '프로젝트 관리: 상업', hi: 'प्रोजेक्ट प्रबंधन: व्यापार', ar: 'إدارة المشاريع: تجارة' }
        // },
        // {
        //   code: 'Projection-Construction',
        //   name: { vi: 'Quản lý dự án thi công', en: 'Project Management: Construction', fr: 'Gestion de projet : Construction', es: 'Gestión de proyectos: Construcción', id: 'Manajemen Proyek: Konstruksi', ja: 'プロジェクト管理: 施工', zh: '项目管理：施工', ko: '프로젝트 관리: 시공', hi: 'प्रोजेक्ट प्रबंधन: निर्माण', ar: 'إدارة المشاريع: إنشاءات' }
        // },
        // {
        //   code: 'Projection-Development',
        //   name: { vi: 'Quản lý dự án R&D', en: 'Project Management: R&D', fr: 'Gestion de projet : R&D', es: 'Gestión de proyectos: I+D', id: 'Manajemen Proyek: R&D', ja: 'プロジェクト管理: R&D', zh: '项目管理：研发', ko: '프로젝트 관리: R&D', hi: 'प्रोजेक्ट प्रबंधन: R&D', ar: 'إدارة المشاريع: بحث وتطوير' }
        // },

        // {
        //   code: 'Office-ITCompany',
        //   name: { vi: 'Văn phòng: Công ty công nghệ', en: 'Office: IT Company', fr: 'Bureau : Société IT', es: 'Oficina: Empresa de TI', id: 'Kantor: Perusahaan TI', ja: 'オフィス: IT企業', zh: '办公：科技公司', ko: '사무실: IT 기업', hi: 'कार्यालय: आईटी कंपनी', ar: 'مكتب: شركة تقنية' }
        // },
        // {
        //   code: 'Office-Startup',
        //   name: { vi: 'Văn phòng: Công ty khởi nghiệp', en: 'Office: Startup', fr: 'Bureau : Startup', es: 'Oficina: Startup', id: 'Kantor: Startup', ja: 'オフィス: スタートアップ', zh: '办公：初创公司', ko: '사무실: 스타트업', hi: 'कार्यालय: स्टार्टअप', ar: 'مكتب: شركة ناشئة' }
        // },
        // {
        //   code: 'Office-DesignAgency',
        //   name: { vi: 'Văn phòng: Thiết kế sáng tạo', en: 'Office: Creative Design Agency', fr: 'Bureau : Design créatif', es: 'Oficina: Diseño creativo', id: 'Kantor: Desain Kreatif', ja: 'オフィス: クリエイティブデザイン', zh: '办公：创意设计', ko: '사무실: 크리에이티브 디자인', hi: 'कार्यालय: क्रिएटिव डिज़ाइन', ar: 'مكتب: تصميم إبداعي' }
        // },
        // {
        //   code: 'Office-MarketingAgency',
        //   name: { vi: 'Văn phòng: Marketing / truyền thông', en: 'Office: Marketing / Media Agency', fr: 'Bureau : Marketing / Médias', es: 'Oficina: Marketing / Medios', id: 'Kantor: Pemasaran / Media', ja: 'オフィス: マーケティング / メディア', zh: '办公：营销 / 传媒', ko: '사무실: 마케팅 / 미디어', hi: 'कार्यालय: मार्केटिंग / मीडिया', ar: 'مكتب: تسويق / إعلام' }
        // },
        // {
        //   code: 'Office-Consulting',
        //   name: { vi: 'Văn phòng: Tư vấn', en: 'Office: Consulting', fr: 'Bureau : Conseil', es: 'Oficina: Consultoría', id: 'Kantor: Konsultan', ja: 'オフィス: コンサル', zh: '办公：咨询', ko: '사무실: 컨설팅', hi: 'कार्यालय: परामर्श', ar: 'مكتب: استشارات' }
        // },
        // {
        //   code: 'Office-LawFirm',
        //   name: { vi: 'Văn phòng: Luật', en: 'Office: Law Firm', fr: 'Bureau : Avocats', es: 'Oficina: Abogados', id: 'Kantor: Hukum', ja: 'オフィス: 法律', zh: '办公：律所', ko: '사무실: 법률', hi: 'कार्यालय: विधि', ar: 'مكتب: محاماة' }
        // },
        // {
        //   code: 'Office-Accounting',
        //   name: { vi: 'Văn phòng: Kế toán / kiểm toán', en: 'Office: Accounting / Auditing', fr: 'Bureau : Comptabilité / Audit', es: 'Oficina: Contabilidad / Auditoría', id: 'Kantor: Akuntansi / Audit', ja: 'オフィス: 会計 / 監査', zh: '办公：会计 / 审计', ko: '사무실: 회계 / 감사', hi: 'कार्यालय: लेखा / ऑडिट', ar: 'مكتب: محاسبة / تدقيق' }
        // },
        // {
        //   code: 'Office-HRService',
        //   name: { vi: 'Văn phòng: Nhân sự / tuyển dụng', en: 'Office: HR / Recruitment', fr: 'Bureau : RH / Recrutement', es: 'Oficina: RR. HH. / Selección', id: 'Kantor: SDM / Rekrutmen', ja: 'オフィス: 人事 / 採用', zh: '办公：人事 / 招聘', ko: '사무실: 인사 / 채용', hi: 'कार्यालय: एचआर / भर्ती', ar: 'مكتب: موارد بشرية / توظيف' }
        // },
        // {
        //   code: 'Office-Architecture',
        //   name: { vi: 'Văn phòng: Thiết kế kiến trúc', en: 'Office: Architecture', fr: 'Bureau : Architecture', es: 'Oficina: Arquitectura', id: 'Kantor: Arsitektur', ja: 'オフィス: 建築設計', zh: '办公：建筑设计', ko: '사무실: 건축 설계', hi: 'कार्यालय: वास्तुकला', ar: 'مكتب: تصميم معماري' }
        // },
        // {
        //   code: 'Office-RealEstateOffice',
        //   name: { vi: 'Văn phòng: Bất động sản', en: 'Office: Real Estate Office', fr: 'Bureau : Immobilier', es: 'Oficina: Inmobiliaria', id: 'Kantor: Properti', ja: 'オフィス: 不動産', zh: '办公：房地产', ko: '사무실: 부동산', hi: 'कार्यालय: रियल एस्टेट', ar: 'مكتب: عقارات' }
        // },
        // {
        //   code: 'Office-Investment',
        //   name: { vi: 'Văn phòng: Đầu tư / tài chính', en: 'Office: Investment / Finance', fr: 'Bureau : Investissement / Finance', es: 'Oficina: Inversión / Finanzas', id: 'Kantor: Investasi / Keuangan', ja: 'オフィス: 投資 / 金融', zh: '办公：投资 / 金融', ko: '사무실: 투자 / 금융', hi: 'कार्यालय: निवेश / वित्त', ar: 'مكتب: استثمار / مالية' }
        // },
        // {
        //   code: 'Office-Training',
        //   name: { vi: 'Văn phòng: Đào tạo nội bộ / kỹ năng', en: 'Office: Internal / Skill Training', fr: 'Bureau : Formation interne / compétences', es: 'Oficina: Formación interna / habilidades', id: 'Kantor: Pelatihan Internal / Keahlian', ja: 'オフィス: 社内 / スキル研修', zh: '办公：内部 / 技能培训', ko: '사무실: 사내 / 직무 교육', hi: 'कार्यालय: आंतरिक / कौशल प्रशिक्षण', ar: 'مكتب: تدريب داخلي / مهارات' }
        // },
        // {
        //     code: 'Office-Other',
        //     name: { vi: 'Văn phòng: Giao việc/chấm công', en: 'Office: Tasks & Attendance', fr: 'Bureau : Tâches / Pointage', es: 'Oficina: Tareas / Asistencia', id: 'Kantor: Tugas / Absensi', ja: 'オフィス: タスク / 勤怠', zh: '办公：任务 / 考勤', ko: '사무실: 업무 / 근태', hi: 'कार्यालय: कार्य / उपस्थिति', ar: 'مكتب: مهام / حضور' }
        // }

        // {
        //   code: 'Education-Preschool',
        //   name: { vi: 'Giáo dục: Trường mầm non', en: 'Education: Preschool', fr: 'Éducation : Maternelle', es: 'Educación: Preescolar', id: 'Pendidikan: Prasekolah', ja: '教育: 幼稚園', zh: '教育：幼儿园', ko: '교육: 유치원', hi: 'शिक्षा: प्री-स्कूल', ar: 'تعليم: روضة أطفال' }
        // },
        // {
        //   code: 'Education-PrimarySchool',
        //   name: { vi: 'Giáo dục: Trường tiểu học', en: 'Education: Primary School', fr: 'Éducation : École primaire', es: 'Educación: Primaria', id: 'Pendidikan: Sekolah Dasar', ja: '教育: 小学校', zh: '教育：小学', ko: '교육: 초등학교', hi: 'शिक्षा: प्राथमिक विद्यालय', ar: 'تعليم: مدرسة ابتدائية' }
        // },
        // {
        //   code: 'Education-SecondarySchool',
        //   name: { vi: 'Giáo dục: Trường THCS', en: 'Education: Secondary School', fr: 'Éducation : Collège', es: 'Educación: Secundaria', id: 'Pendidikan: SMP', ja: '教育: 中学校', zh: '教育：初中', ko: '교육: 중학교', hi: 'शिक्षा: माध्यमिक विद्यालय', ar: 'تعليم: مدرسة إعدادية' }
        // },
        // {
        //   code: 'Education-Highschool',
        //   name: { vi: 'Giáo dục: Trường THPT', en: 'Education: High School', fr: 'Éducation : Lycée', es: 'Educación: Bachillerato', id: 'Pendidikan: SMA', ja: '教育: 高校', zh: '教育：高中', ko: '교육: 고등학교', hi: 'शिक्षा: हाई स्कूल', ar: 'تعليم: مدرسة ثانوية' }
        // },
        // {
        //   code: 'Education-University',
        //   name: { vi: 'Giáo dục: Đại học / cao đẳng', en: 'Education: University / College', fr: 'Éducation : Enseignement supérieur', es: 'Educación: Universidad / Instituto', id: 'Pendidikan: Universitas / Akademi', ja: '教育: 大学 / 短大', zh: '教育：大学 / 大专', ko: '교육: 대학교 / 전문대', hi: 'शिक्षा: विश्वविद्यालय / कॉलेज', ar: 'تعليم: جامعة / كلية' }
        // },
        // {
        //   code: 'Education-TrainingLanguage',
        //   name: { vi: 'Giáo dục: Ngoại ngữ', en: 'Education: Language Training', fr: 'Éducation : Langues', es: 'Educación: Idiomas', id: 'Pendidikan: Bahasa Asing', ja: '教育: 語学', zh: '教育：外语', ko: '교육: 외국어', hi: 'शिक्षा: विदेशी भाषा', ar: 'تعليم: لغات أجنبية' }
        // },
        // {
        //   code: 'Education-TrainingVocational',
        //   name: { vi: 'Giáo dục: Đào tạo nghề', en: 'Education: Vocational Training', fr: 'Éducation : Formation pro', es: 'Educación: Formación profesional', id: 'Pendidikan: Kejuruan', ja: '教育: 職業訓練', zh: '教育：职业培训', ko: '교육: 직업 훈련', hi: 'शिक्षा: व्यावसायिक प्रशिक्षण', ar: 'تعليم: تدريب مهني' }
        // },
        // {
        //   code: 'Education-TrainingSTEM',
        //   name: { vi: 'Giáo dục: STEM / lập trình trẻ em', en: 'Education: STEM / Kids Coding', fr: 'Éducation : STEM / Code pour enfants', es: 'Educación: STEM / Programación infantil', id: 'Pendidikan: STEM / Coding Anak', ja: '教育: STEM / 子ども向けプログラミング', zh: '教育：STEM / 少儿编程', ko: '교육: STEM / 어린이 코딩', hi: 'शिक्षा: STEM / बच्चों की कोडिंग', ar: 'تعليم: STEM / برمجة للأطفال' }
        // },
        // {
        //   code: 'Education-Other',
        //   name: { vi: 'Giáo dục: Khác', en: 'Education: Other', fr: 'Éducation : Autre', es: 'Educación: Otros', id: 'Pendidikan: Lainnya', ja: '教育: その他', zh: '教育：其他', ko: '교육: 기타', hi: 'शिक्षा: अन्य', ar: 'تعليم: أخرى' }
        // }
    ];

    // .sort((a, b) => (a.name < b.name ? -1 : 1));

    const blockValidation = useRef(false);

    const vGroup1 = useRef();
    const vGroup1_2 = useRef();
    const txtbusSubIndustry = useRef();
    const txtbusBaseCurrency = useRef();
    const txtBusName = useRef();
    const txtBusShortCode = useRef();
    const txtOwnerFullName = useRef();
    const txtOwnerEmail = useRef();
    const txtOwnerPhone = useRef();
    const txtOwnerOTP = useRef();

    const busZoneCode = useRef();

    useEffect(() => {
        if (currentStage === 'Step1') if (txtBusName.current && txtBusName.current.instance) txtBusName.current.instance.focus();
        if (currentStage === 'Step3') if (txtOwnerOTP.current && txtOwnerOTP.current.instance) txtOwnerOTP.current.instance.focus();
    }, [currentStage]);

    useEffect(() => {
        var storedCurrency = localStorage.getItem(cs.System_Code + '-Sys_DefaultCurrency');
        if (storedCurrency && storedCurrency !== 'null' && storedCurrency !== 'undefined') {
            setBaseCurrency(storedCurrency);
        }

        var value = localStorage.getItem(cs.System_Code + '-Sys_RegisterWithPhoneNumber');
        value = !value || value === 'null' || value === 'undefined' || value === 'true';
        setUsePhoneNumber(value);

        // Language user đã chọn TRƯỚC đó (switch trên giao diện) → ưu tiên cao nhất
        var userChosenLanguage = localStorage.getItem(cs.System_Code + '-Sys_BaseLanguage');
        var hasUserChosenLanguage = userChosenLanguage && userChosenLanguage !== 'null' && userChosenLanguage !== 'undefined';

        // Load country defaults từ server (detect IP → gợi ý quốc gia)
        AntBusiness.registerPrepare(function (res) {
            var d = res && res.data ? res.data : null;

            // ─── Country list: API → offline fallback từ currencies.json ──
            if (d && d.countries && d.countries.length > 0) {
                setCountryList(d.countries);
            } else {
                // Offline fallback: build country list từ currencies.json (đã import sẵn)
                var seen = {};
                var offlineList = [];
                currencies.forEach(function (c) {
                    if (c.country && !seen[c.country]) {
                        seen[c.country] = true;
                        offlineList.push({ code: c.country, name: c.country, currency: c.code, language: c.locale || 'en' });
                    }
                });
                setCountryList(offlineList);
            }

            if (d && d.is_country_locked) setIsCountryLocked(true);

            if (d && d.suggested) {
                var suggestedCountry = d.suggested.country_code;
                // Country: luôn set từ IP detect
                if (suggestedCountry) setBaseCountry(suggestedCountry);
                // Currency: set từ country detect
                if (d.suggested.currency) setBaseCurrency(d.suggested.currency);
                if (d.suggested.allowed_currencies) setAllowedCurrencies(d.suggested.allowed_currencies);
                // Language: signup mới → LUÔN theo quốc gia (KHÔNG dùng localStorage của session cũ).
                // Doanh nghiệp mới phải khớp ngôn ngữ với quốc gia đăng ký.
                if (d.suggested.language) {
                    setBaseLanguage(d.suggested.language);
                } else if (hasUserChosenLanguage) {
                    setBaseLanguage(userChosenLanguage);
                }
                // #9: Timezone theo country (không theo browser)
                if (d.suggested.timezone) setBaseTimezone(d.suggested.timezone);
                // Phone OTP bật cho MỌI nước (eSMS cho VN, Twilio cho nước khác) — theo setting đã đọc ở trên.
            }
        });
    }, []);

    useEffect(() => {
        if (!busShortCode) {
            var txtValue = KhongDau(AntString.compoundUnicode(String(busName)).toUpperCase().trim());

            setBusShortCode(
                String(txtValue)
                    .replace(' ', '')
                    .replace(/[^a-zA-Z0-9]/g, '')
            );
        }
    }, [busName]);

    const { appInfo, appAssets } = appGlobal;
    var title = appInfo && appInfo.title ? appInfo.title : '';
    var logoOnly = appAssets && appAssets.images.logoOnly ? appAssets.images.logoOnly : undefined;
    var logoWithBrand =
        appAssets && appAssets.images.authLogoTagline
            ? appAssets.images.authLogoTagline
            : appAssets && appAssets.images.logoWithBrandSlogun
            ? appAssets.images.logoWithBrandSlogun
            : undefined;

    const step1Request = useCallback(() => {
        if (!vGroup1.current || !vGroup1.current.instance || !vGroup1.current.instance.validate().isValid) return;

        setErrorText(null);
        setCurrentStage('Step2');
    }, []);

    const step2RequestWithPhoneAndEmail = useCallback(() => {
        if (!vGroup1_2.current || !vGroup1_2.current.instance || !vGroup1_2.current.instance.validate().isValid) return;

        setErrorText(null);
        setRegisterType('WithPhoneAndEmail');

        const { appInfo } = appGlobal;

        // Normalize phone to E.164 using baseCountry; fallback to raw digits so legacy flows still work
        var rawPhone = String(ownerPhone || '').replace(/\s/g, '');
        var e164Phone = undefined;
        var phoneCountry = baseCountry || undefined;
        if (rawPhone) {
            try {
                var parsed = parsePhoneNumberFromString(rawPhone, baseCountry || undefined);
                if (parsed && parsed.isValid()) {
                    e164Phone = parsed.number; // E.164 "+8498..."
                    phoneCountry = parsed.country || baseCountry || undefined;
                }
            } catch (e) { /* ignore — BE will re-validate and default to VN */ }
            if (!e164Phone) {
                // Couldn't parse: pass through digits (BE handles VN fallback for legacy FE)
                var digits = rawPhone.replace(/[^0-9]/g, '');
                e164Phone = parseInt(digits) ? digits : undefined;
            }
        }

        AntBusiness.registerRequest(
            {
                type: 'WithPhoneAndEmail',
                app_id: appInfo.appId,
                sub_industry: subIndustry,
                country_code: baseCountry,
                timezone: baseTimezone,
                Sys_BaseCurrency: baseCurrency,
                Sys_BaseLanguage: baseLanguage,
                name: busName,
                short_code: busShortCode,
                owner_fullname: ownerFullName,
                owner_phone: e164Phone,
                owner_phone_country: phoneCountry,
                owner_email: ownerEmail
            },
            (res) => {
                if (res && res.error) setErrorText(res.error);
                if (res && res.data && res.data.sent) {
                    busZoneCode.current = res.data.zone_code;
                    setCurrentStage('Step3');
                    setCurrentToken(res.data.token);
                    setOwnerOTP('');

                    if (res && res.data && res.data.message) setMessage(res.data.message);

                    if (txtOwnerOTP.current) txtOwnerOTP.current.instance.focus();
                }
                // this.vGroup1.reset();
            }
        );
    }, [ownerPhone, subIndustry, baseCurrency, baseLanguage, baseCountry, baseTimezone, busName, busShortCode, ownerFullName, ownerEmail, appGlobal]);

    const step2RequestWithGoogle = useCallback(
        (customData) => {
            // console.log('ant-log-customData : ',customData);
            setErrorText(null);

            const { appInfo } = appGlobal;

            setCurrentStage('Step5');

            AntBusiness.registerRequest(
                {
                    type: 'WithGoogleAccount',
                    app_id: appInfo.appId,
                    sub_industry: subIndustry,
                    country_code: baseCountry,
                    Sys_BaseCurrency: baseCurrency,
                    Sys_BaseLanguage: baseLanguage,
                    name: busName,
                    short_code: busShortCode,
                    // owner_fullname: ownerFullName,
                    // owner_email: ownerEmail,
                    // ...customData
                    googleCode: customData.googleCode
                },
                (res) => {
                    if (res && res.error) setErrorText(res.error);

                    if (res && res.data && res.data.session) {
                        AntAuth.saveSessionData(res.data.session, true, () => {
                            window.location.href = '/home';
                        });
                        setCurrentStage('Step6');
                        return;
                    }
                    // this.vGroup1.reset();
                }
            );
        },
        [ownerFullName, subIndustry, baseCurrency, baseLanguage, baseCountry, busName, busShortCode, ownerEmail, appGlobal]
    );

    const loginWithGoogle = useGoogleLogin({
        flow: 'auth-code',
        onSuccess: async (data) => {
            setRegisterType('WithGoogleAccount');

            step2RequestWithGoogle({
                googleCode: data.code
            });

            // fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
            //     headers: {
            //         Authorization: `Bearer ${tokenResponse.access_token}`
            //     }
            // })
            //     .then((response) => response.json())
            //     .then((data) => {
            //         console.log('User info:', data);
            //         if (data && data.email) {
            //             setOwnerEmail(data.email);
            //             setOwnerFullName(data.name);
            //             step2RequestWithGoogle({
            //                 owner_fullname: data.name,
            //                 owner_email: data.email
            //             });
            //         }
            //     })
            //     .catch((er) => {});
        }
    });

    // Không còn bước đặt mật khẩu: OTP đúng là tạo doanh nghiệp và vào thẳng app.
    // Chủ doanh nghiệp đặt mật khẩu sau trong app hoặc qua "Quên mật khẩu".
    const finishingRegister = useRef(false);
    const finishRegister = useCallback(
        (otp) => {
            // Ô OTP tự gửi khi đủ 6 số nên có thể bắn 2 lần; chỉ tạo doanh nghiệp một lần.
            if (finishingRegister.current) return;
            finishingRegister.current = true;
            setErrorText(null);
            setCurrentStage('Step5');

            AntBusiness.registerSetAdminPassword(
                {
                    type: registerType,
                    token: currentToken,
                    otp: otp,
                    zone_code: busZoneCode.current
                },
                (res) => {
                    if (res && res.error) {
                        setErrorText(null);
                        setCurrentStage('Step6');
                        setLogging(true);
                    }
                    if (res && res.data && res.data.session) {
                        AntAuth.saveSessionData(res.data.session, true, () => {
                            window.location.href = '/home';
                        });
                    }
                }
            );
        },
        [registerType, currentToken]
    );

    const step3VerifyOTP = useCallback(
        (otp) => {
            setErrorText(null);

            AntBusiness.registerVerifyOTP(
                {
                    token: currentToken,
                    otp: otp,
                    zone_code: busZoneCode.current
                },
                (res) => {
                    if (res && res.error) setErrorText(res.error);
                    if (res && res.data && res.data.valid_otp) finishRegister(otp);
                }
            );
        },
        [currentToken, finishRegister]
    );

    useEffect(() => {
        let isValid =
            currentStage === 'Step1' &&
            // this.state.busModel &&
            subIndustry &&
            baseCurrency &&
            busName &&
            busShortCode;
        // ownerFullName &&
        // ownerPhone &&

        if (isValid) {
            if (vGroup1?.current?.instance) {
                isValid = vGroup1.current.instance.validate().isValid;
            }
        }
        setStep1Processable(isValid);
    }, [currentStage, subIndustry, baseCurrency, busName, busShortCode]);

    useEffect(() => {
        let isValid =
            currentStage === 'Step2' &&
            // this.state.busModel &&
            subIndustry &&
            baseCurrency &&
            busName &&
            busShortCode &&
            // ownerFullName &&
            (ownerPhone || ownerEmail);

        if (isValid) {
            if (vGroup1_2?.current?.instance) {
                isValid = vGroup1_2.current.instance.validate().isValid;
            }
        }
        setStep2Processable(isValid);
    }, [currentStage, subIndustry, baseCurrency, busName, busShortCode, ownerPhone, ownerEmail]);

    if (hasBusShortCode) {
        return (
            <AntCardLayout width={380} scale={1.0} marginLeft={props.marginLeft} marginRight={props.marginRight}>
                <div className={'register-header'}>
                    {!logoWithBrand && <div className={'title'}>{appInfo.title}</div>}
                    {logoWithBrand && <img src={logoWithBrand} style={{ width: '160px' }} />}
                </div>
                {/* 
                <div className={'dx-field'} style={{ marginLeft: '-18px' }}>
                    <AntErrorPanel
                        text={AntLocalization.translateText({ vi: 'Không hỗ trợ !', en: 'Not supported!', fr: 'Non pris en charge !', es: '¡No compatible!', id: 'Tidak didukung!', ja: '非対応！', zh: '不支持！', ko: '지원되지 않습니다!', hi: 'समर्थित नहीं है!', ar: 'غير مدعوم!' })}
                    />
                </div> */}
                <div className={'dx-field'} style={{ marginTop: '10px' }}>
                    <Link to={'/login'}>
                        {AntLocalization.translateText({ vi: 'Đăng nhập tại đây.', en: 'Log in here.', fr: 'Connectez-vous ici.', es: 'Inicie sesión aquí.', id: 'Masuk di sini.', ja: 'こちらからログイン', zh: '在此登录', ko: '여기서 로그인', hi: 'यहाँ लॉगिन करें', ar: 'سجّل الدخول هنا.' })}
                    </Link>
                </div>
            </AntCardLayout>
        );
    }

    // #7: Phone code prefix theo quốc gia
    var phoneCode = '';
    var countryData = countryList.find(function (c) { return c.code === baseCountry; });
    if (countryData && countryData.phone_code) phoneCode = countryData.phone_code;

    // #7b: Validate + gợi ý format số điện thoại THEO NƯỚC (libphonenumber).
    // Nước libphonenumber KHÔNG hỗ trợ → nhập LINH ĐỘNG (không validate cứng).
    var phoneSupported = !!(baseCountry && isSupportedCountry(baseCountry));
    var phoneExample = '';
    if (phoneSupported) {
        try {
            var _exNum = getExampleNumber(baseCountry, phoneExamples);
            phoneExample = _exNum ? _exNum.formatNational() : '';
        } catch (e) {}
    }

    // #6: Language support note — kiểm tra ngôn ngữ country có trong danh sách hỗ trợ không
    var supportedLangs = ['vi', 'en', 'fr', 'es', 'id', 'ja', 'zh', 'ko', 'hi', 'ar'];
    var countryLang = countryData && countryData.language ? countryData.language.substring(0, 2) : '';
    var isLangSupported = !countryLang || supportedLangs.indexOf(countryLang) >= 0;

    if (!logging)
        return (
            <AntCardLayout width={400} scale={1.0} marginLeft={props.marginLeft} marginRight={props.marginRight}>
                <div className={'register-header'}>
                    {!logoWithBrand && <div className={'title'}>{appInfo.title}</div>}
                    {logoWithBrand && <img src={logoWithBrand} style={{ width: '120px' }} />}
                </div>

                {currentStage === 'Step1' && (
                    <ValidationGroup ref={vGroup1} className={'register-panel'}>
                        <div className={'dx-field'}>
                            <SelectBox
                                ref={txtbusSubIndustry}
                                items={subIndustries.map((s) => {
                                    return { code: s.code, name: AntLocalization.translateText(s.name) };
                                })}
                                placeholder={AntLocalization.translateText({ vi: 'Ngành nghề', en: 'Industry', fr: 'Secteur', es: 'Industria', id: 'Industri', ja: '業種', zh: '行业', ko: '업종', hi: 'उद्योग', ar: 'الصناعة' })}
                                showClearButton={false}
                                showDropDownButton={false}
                                className={'register-sub-bus-industry'}
                                value={subIndustry}
                                displayExpr={'name'}
                                valueExpr={'code'}
                                itemRender={(e) => {
                                    return <div className="register-sub-bus-industry-name">{e.name}</div>;
                                }}
                                onValueChanged={(e) => {
                                    setSubIndustry(e.value);
                                    if (txtBusName.current) txtBusName.current.instance.focus();
                                }}
                            >
                                <Validator>
                                    <RequiredRule
                                        message={AntLocalization.translateText({ vi: 'Không được trống !', en: 'Cannot be empty!', fr: 'Ne peut pas être vide !', es: '¡No puede estar vacío!', id: 'Tidak boleh kosong!', ja: '空にできません！', zh: '不能为空！', ko: '비워둘 수 없습니다!', hi: 'खाली नहीं हो सकता!', ar: 'لا يمكن أن يكون فارغاً!' })}
                                    />
                                </Validator>
                                <TextBoxButton
                                    name="subIndustry"
                                    location="before"
                                    options={{
                                        icon: 'coffee',
                                        stylingMode: 'text',
                                        focusStateEnabled: false,
                                        activeStateEnabled: false,
                                        hoverStateEnabled: false,
                                        type: 'default'
                                    }}
                                />
                            </SelectBox>
                        </div>
                        {/* 
                            <div className={'dx-field'}>
                                <SelectBox
                                    ref={txtBusModel}
                                    items={[
                                        { code: 'Individual', name: 'Hộ kinh doanh' },
                                        { code: 'Company', name: 'Doanh nghiệp' }
                                    ]}
                                    placeholder={'Loại hình'}
                                    showClearButton={false}
                                    showDropDownButton={false}
                                    className={'register-bus-model'}
                                    value={busModel}
                                    displayExpr={'name'}
                                    valueExpr={'code'}
                                    itemRender={(e) => {
                                        return <div className="register-bus-model-name">{e.name}</div>;
                                    }}
                                    onValueChanged={(e) => {
                                        this.setState({ busModel: e.value });
                                        if (txtBusName.current) txtBusName.current.instance.focus();
                                    }}
                                >
                                    <Validator>
                                        <RequiredRule message={'Không được trống !'} />
                                    </Validator>
                                    <TextBoxButton
                                        name="busModel"
                                        location="before"
                                        options={{
                                            icon: 'globe',
                                            stylingMode: 'text',
                                            focusStateEnabled: false,
                                            activeStateEnabled: false,
                                            hoverStateEnabled: false,
                                            type: 'default'
                                        }}
                                    />
                                </SelectBox>
                            </div> */}

                        <div className={'dx-field'}>
                            <TextBox
                                ref={txtBusName}
                                value={busName}
                                placeholder={AntLocalization.translateText({ vi: 'Tên đăng ký kinh doanh', en: 'Business Name', fr: "Nom de l'entreprise", es: 'Nombre de la empresa', id: 'Nama Bisnis', ja: '企業名', zh: '企业名称', ko: '사업자명', hi: 'व्यवसाय का नाम', ar: 'اسم العمل' })}
                                width={'100%'}
                                maxLength={64}
                                className={'register-bus-name'}
                                onValueChanged={(e) => {
                                    setBusName(String(e.value).toUpperCase().trim());
                                }}
                                onEnterKey={(e) => {
                                    if (txtBusShortCode.current) txtBusShortCode.current.instance.focus();
                                }}
                                onFocusIn={(e) => {
                                    let inputEl = e.element.querySelector('.dx-texteditor-input');
                                    if (inputEl) {
                                        inputEl.selectionStart = 0;
                                        inputEl.selectionEnd = inputEl.value.length;
                                    }
                                }}
                            >
                                <Validator>
                                    <RequiredRule
                                        message={AntLocalization.translateText({ vi: 'Không được trống !', en: 'Cannot be empty!', fr: 'Ne peut pas être vide !', es: '¡No puede estar vacío!', id: 'Tidak boleh kosong!', ja: '空にできません！', zh: '不能为空！', ko: '비워둘 수 없습니다!', hi: 'खाली नहीं हो सकता!', ar: 'لا يمكن أن يكون فارغاً!' })}
                                    />
                                    <StringLengthRule
                                        message={AntLocalization.translateText({ vi: 'Tối thiểu 6 ký tự', en: 'Minimum 6 characters', fr: '6 caractères minimum', es: 'Mínimo 6 caracteres', id: 'Minimal 6 karakter', ja: '最低6文字', zh: '至少6个字符', ko: '최소 6자', hi: 'न्यूनतम 6 वर्ण', ar: '6 أحرف على الأقل' })}
                                        min={6}
                                    />
                                    <StringLengthRule
                                        message={AntLocalization.translateText({ vi: 'Tối đa 64 ký tự', en: 'Maximum 64 characters', fr: '64 caractères maximum', es: 'Máximo 64 caracteres', id: 'Maksimal 64 karakter', ja: '最大64文字', zh: '最多64个字符', ko: '최대 64자', hi: 'अधिकतम 64 वर्ण', ar: '64 حرفًا كحد أقصى' })}
                                        max={64}
                                    />
                                    <PatternRule
                                        message={AntLocalization.translateText({ vi: 'Không được chứa ký tự đặc biệt !', en: 'Special characters are not allowed!', fr: 'Les caractères spéciaux ne sont pas autorisés !', es: '¡No se permiten caracteres especiales!', id: 'Karakter khusus tidak diizinkan!', ja: '特殊文字は使用できません！', zh: '不允许使用特殊字符！', ko: '특수 문자는 허용되지 않습니다!', hi: 'विशेष वर्णों की अनुमति नहीं है!', ar: 'الأحرف الخاصة غير مسموح بها!' })}
                                        pattern={'^[^\\`~!#$%^&*()=+\\[\\]{}\\|;\':",<>?/]+$'}
                                    />
                                </Validator>
                                <TextBoxButton
                                    name="busName"
                                    location="before"
                                    options={{
                                        icon: 'product',
                                        stylingMode: 'text',
                                        focusStateEnabled: false,
                                        activeStateEnabled: false,
                                        hoverStateEnabled: false,
                                        type: 'default'
                                    }}
                                />
                            </TextBox>
                        </div>

                        <div className={'dx-field'}>
                            <TextBox
                                ref={txtBusShortCode}
                                value={busShortCode}
                                placeholder={AntLocalization.translateText({ vi: 'Mã doanh nghiệp', en: 'Business Code', fr: 'Code entreprise', es: 'Código de empresa', id: 'Kode Bisnis', ja: 'ビジネスコード', zh: '企业代码', ko: '사업자 코드', hi: 'व्यवसाय कोड', ar: 'رمز العمل' })}
                                width={'100%'}
                                className={'register-bus-shortcode'}
                                maxLength={20}
                                inputAttr={{
                                    style: 'text-transform: uppercase'
                                }}
                                onValueChanged={(e) => {
                                    setBusShortCode(String(e.value).toUpperCase().trim().replace(' ', ''));
                                }}
                                onEnterKey={(e) => {
                                    // if (txtOwnerFullName.current) txtOwnerFullName.current.instance.focus();
                                    if (txtOwnerPhone.current) txtOwnerPhone.current.instance.focus();
                                }}
                                onFocusIn={(e) => {
                                    let inputEl = e.element.querySelector('.dx-texteditor-input');
                                    if (inputEl) {
                                        inputEl.selectionStart = 0;
                                        inputEl.selectionEnd = inputEl.value.length;
                                    }
                                }}
                            >
                                <Validator>
                                    <RequiredRule
                                        message={AntLocalization.translateText({ vi: 'Không được trống !', en: 'Cannot be empty!', fr: 'Ne peut pas être vide !', es: '¡No puede estar vacío!', id: 'Tidak boleh kosong!', ja: '空にできません！', zh: '不能为空！', ko: '비워둘 수 없습니다!', hi: 'खाली नहीं हो सकता!', ar: 'لا يمكن أن يكون فارغاً!' })}
                                    />
                                    <StringLengthRule
                                        message={AntLocalization.translateText({ vi: 'Tối thiểu 5 ký tự', en: 'Minimum 5 characters', fr: 'Minimum 5 caractères', es: 'Mínimo 5 caracteres', id: 'Minimal 5 karakter', ja: '最低5文字', zh: '至少5个字符', ko: '최소 5자', hi: 'न्यूनतम 5 वर्ण', ar: '5 أحرف على الأقل' })}
                                        min={5}
                                    />
                                    <StringLengthRule
                                        message={AntLocalization.translateText({ vi: 'Tối đa 20 ký tự', en: 'Maximum 20 characters', fr: '20 caractères maximum', es: 'Máximo 20 caracteres', id: 'Maksimal 20 karakter', ja: '最大20文字', zh: '最多20个字符', ko: '최대 20자', hi: 'अधिकतम 20 वर्ण', ar: '20 حرفًا كحد أقصى' })}
                                        max={20}
                                    />
                                    <PatternRule
                                        message={AntLocalization.translateText({ vi: 'Không được chứa ký tự đặc biệt !', en: 'Special characters are not allowed!', fr: 'Les caractères spéciaux ne sont pas autorisés !', es: '¡No se permiten caracteres especiales!', id: 'Karakter khusus tidak diizinkan!', ja: '特殊文字は使用できません！', zh: '不允许使用特殊字符！', ko: '특수 문자는 허용되지 않습니다!', hi: 'विशेष वर्णों की अनुमति नहीं है!', ar: 'الأحرف الخاصة غير مسموح بها!' })}
                                        pattern={'^[^\\`~!#$%^&*()=+\\[\\]{}\\|;\':",<>?/]+$'}
                                    />

                                    <PatternRule
                                        message={AntLocalization.translateText({ vi: 'Không được nhập khoảng trắng !', en: 'No spaces allowed !', fr: 'Espaces interdits !', es: '¡No se permiten espacios!', id: 'Spasi tidak diizinkan!', ja: 'スペースは使用できません！', zh: '不允许输入空格！', ko: '공백은 허용되지 않습니다!', hi: 'रिक्त स्थान की अनुमति नहीं है!', ar: 'المسافات غير مسموح بها!' })}
                                        pattern={/^[^\s]+$/}
                                    />
                                    <AsyncRule
                                        message={AntLocalization.translateText({ vi: 'Mã doanh nghiệp đã tồn tại !', en: 'Business code already exists !', fr: "Ce code d'entreprise existe déjà !", es: '¡El código de empresa ya existe!', id: 'Kode bisnis sudah ada!', ja: '企業コードは既に存在します！', zh: '企业代码已存在！', ko: '사업자 코드가 이미 존재합니다!', hi: 'व्यवसाय कोड पहले से मौजूद है!', ar: 'رمز العمل موجود بالفعل!' })}
                                        validationCallback={async (e) => {
                                            if (blockValidation.current) return true;
                                            blockValidation.current = true;
                                            var isExisted = await AntBusiness.isShortCodeExisted(String(e.value));
                                            blockValidation.current = false;

                                            if (isExisted)
                                                setErrorText(
                                                    AntLocalization.translateText({ vi: 'Mã doanh nghiệp đã tồn tại !', en: 'Business code already exists !', fr: "Ce code d'entreprise existe déjà !", es: '¡El código de empresa ya existe!', id: 'Kode bisnis sudah ada!', ja: '企業コードは既に存在します！', zh: '企业代码已存在！', ko: '사업자 코드가 이미 존재합니다!', hi: 'व्यवसाय कोड पहले से मौजूद है!', ar: 'رمز العمل موجود بالفعل!' })
                                                );

                                            return !Boolean(isExisted);
                                        }}
                                    />
                                </Validator>
                                <TextBoxButton
                                    name="busName"
                                    location="before"
                                    options={{
                                        icon: 'key',
                                        stylingMode: 'text',
                                        focusStateEnabled: false,
                                        activeStateEnabled: false,
                                        hoverStateEnabled: false,
                                        type: 'default'
                                    }}
                                />
                            </TextBox>
                        </div>
                        {/* Country selection — auto-detect từ IP, chọn → cập nhật currency + language.
                            Máy chủ khoá quốc gia (is_country_locked) → ẩn hẳn, không chỉ disable:
                            hiện ra chỉ gây hiểu nhầm là chọn được. */}
                        {!isCountryLocked && (
                        <div className={'dx-field'}>
                            <SelectBox
                                items={countryList.length > 0 ? countryList.map(function (c) {
                                    return { code: c.code, name: (c.flag ? c.flag + '  ' : '') + c.name };
                                }) : currencies.map(function (s) {
                                    return { code: s.country || s.code, name: s.country || s.code };
                                })}
                                placeholder={AntLocalization.translateText({ vi: 'Quốc gia', en: 'Country', fr: 'Pays', es: 'País', id: 'Negara', ja: '国', zh: '国家', ko: '국가', hi: 'देश', ar: 'الदولة' })}
                                showClearButton={false}
                                showDropDownButton={false}
                                searchEnabled={true}
                                className={'register-sub-bus-industry register-country-select'}
                                dropDownOptions={{ wrapperAttr: { class: 'register-country-popup' } }}
                                value={baseCountry}
                                displayExpr={'name'}
                                valueExpr={'code'}
                                disabled={isCountryLocked}
                                itemRender={function (e) {
                                    return <div className="register-country-name">{e && e.name}</div>;
                                }}
                                onValueChanged={function (e) {
                                    setBaseCountry(e.value);
                                    // Auto-fill currency từ country (luôn cập nhật — currency phụ thuộc nơi kinh doanh)
                                    var found = countryList.find(function (c) { return c.code === e.value; });
                                    if (found) {
                                        if (found.currency) setBaseCurrency(found.currency);
                                        setAllowedCurrencies(found.allowed_currencies || (found.currency ? [found.currency] : []));
                                        // User chủ động đổi quốc gia → luôn cập nhật ngôn ngữ theo quốc gia mới
                                        if (found.language) setBaseLanguage(found.language);
                                    }
                                    // #9: Timezone theo country
                                    if (found && found.timezone) setBaseTimezone(found.timezone);
                                    // Phone OTP bật cho MỌI nước (eSMS/Twilio) — giữ theo setting, không tắt theo quốc gia.
                                }}
                            >
                                <TextBoxButton
                                    name="baseCountry"
                                    location="before"
                                    options={{
                                        icon: 'globe',
                                        stylingMode: 'text',
                                        focusStateEnabled: false,
                                        activeStateEnabled: false,
                                        hoverStateEnabled: false,
                                        type: 'default'
                                    }}
                                />
                            </SelectBox>
                            {baseCountry && !isLangSupported && (
                                <div style={{ fontSize: 11, color: '#F59E0B', marginTop: 2, paddingLeft: 34 }}>
                                    {AntLocalization.translateText({ vi: 'Giao diện hỗ trợ: English, Tiếng Việt, Fran\u00e7ais, Espa\u00f1ol, Bahasa, \u65e5\u672c\u8a9e, \u4e2d\u6587, \ud55c\uad6d\uc5b4, \u0939\u093f\u0928\u094d\u0926\u0940, \u0627\u0644\u0639\u0631\u0628\u064a\u0629', en: 'Interface available in: English, Ti\u1ebfng Vi\u1ec7t, Fran\u00e7ais, Espa\u00f1ol, Bahasa, \u65e5\u672c\u8a9e, \u4e2d\u6587, \ud55c\uad6d\uc5b4, \u0939\u093f\u0928\u094d\u0926\u0940, \u0627\u0644\u0639\u0631\u0628\u064a\u0629', fr: 'Interface disponible en: English, Ti\u1ebfng Vi\u1ec7t, Fran\u00e7ais, Espa\u00f1ol, Bahasa, \u65e5\u672c\u8a9e, \u4e2d\u6587, \ud55c\uad6d\uc5b4, \u0939\u093f\u0928\u094d\u0926\u0940, \u0627\u0644\u0639\u0631\u0628\u064a\u0629', es: 'Interfaz disponible en: English, Ti\u1ebfng Vi\u1ec7t, Fran\u00e7ais, Espa\u00f1ol, Bahasa, \u65e5\u672c\u8a9e, \u4e2d\u6587, \ud55c\uad6d\uc5b4, \u0939\u093f\u0928\u094d\u0926\u0940, \u0627\u0644\u0639\u0631\u0628\u064a\u0629', id: 'Antarmuka tersedia dalam: English, Ti\u1ebfng Vi\u1ec7t, Fran\u00e7ais, Espa\u00f1ol, Bahasa, \u65e5\u672c\u8a9e, \u4e2d\u6587, \ud55c\uad6d\uc5b4, \u0939\u093f\u0928\u094d\u0926\u0940, \u0627\u0644\u0639\u0631\u0628\u064a\u0629', ja: '\u5229\u7528\u53ef\u80fd\u306a\u8a00\u8a9e: English, Ti\u1ebfng Vi\u1ec7t, Fran\u00e7ais, Espa\u00f1ol, Bahasa, \u65e5\u672c\u8a9e, \u4e2d\u6587, \ud55c\uad6d\uc5b4, \u0939\u093f\u0928\u094d\u0926\u0940, \u0627\u0644\u0639\u0631\u0628\u064a\u0629', zh: '\u754c\u9762\u652f\u6301: English, Ti\u1ebfng Vi\u1ec7t, Fran\u00e7ais, Espa\u00f1ol, Bahasa, \u65e5\u672c\u8a9e, \u4e2d\u6587, \ud55c\uad6d\uc5b4, \u0939\u093f\u0928\u094d\u0926\u0940, \u0627\u0644\u0639\u0631\u0628\u064a\u0629', ko: '\uc778\ud130\ud398\uc774\uc2a4 \uc9c0\uc6d0: English, Ti\u1ebfng Vi\u1ec7t, Fran\u00e7ais, Espa\u00f1ol, Bahasa, \u65e5\u672c\u8a9e, \u4e2d\u6587, \ud55c\uad6d\uc5b4, \u0939\u093f\u0928\u094d\u0926\u0940, \u0627\u0644\u0639\u0631\u0628\u064a\u0629', hi: '\u0907\u0902\u091f\u0930\u092b\u093c\u0947\u0938 \u0909\u092a\u0932\u092c\u094d\u0927: English, Ti\u1ebfng Vi\u1ec7t, Fran\u00e7ais, Espa\u00f1ol, Bahasa, \u65e5\u672c\u8a9e, \u4e2d\u6587, \ud55c\uad6d\uc5b4, \u0939\u093f\u0928\u094d\u0926\u0940, \u0627\u0644\u0639\u0631\u0628\u064a\u0629', ar: '\u0627\u0644\u0648\u0627\u062c\u0647\u0629 \u0645\u062a\u0648\u0641\u0631\u0629 \u0628\u0640: English, Ti\u1ebfng Vi\u1ec7t, Fran\u00e7ais, Espa\u00f1ol, Bahasa, \u65e5\u672c\u8a9e, \u4e2d\u6587, \ud55c\uad6d\uc5b4, \u0939\u093f\u0928\u094d\u0926\u0940, \u0627\u0644\u0639\u0631\u0628\u064a\u0629' })}
                                </div>
                            )}
                        </div>
                        )}
                        {/* Currency — đa số quốc gia chỉ 1 đồng tiền (đã tự gán, ẩn hẳn ô này, cùng
                            lý do ẩn quốc gia ở trên). Vài nước lưu hành song song nhiều đồng tiền
                            (vd Campuchia KHR+USD) → hiện dropdown nhưng CHỈ trong allowedCurrencies. */}
                        {allowedCurrencies.length !== 1 && (
                        <div className={'dx-field'}>
                            <SelectBox
                                ref={txtbusBaseCurrency}
                                items={(allowedCurrencies.length > 0
                                    ? currencies.filter((s) => allowedCurrencies.indexOf(s.code) !== -1)
                                    : currencies
                                ).map((s) => {
                                    return { code: s.code, name: AntLocalization.translateText(s.name) };
                                })}
                                placeholder={AntLocalization.translateText({ vi: 'Tiền tệ', en: 'Base Currency', fr: 'Devise de base', es: 'Moneda base', id: 'Mata Uang', ja: '基本通貨', zh: '基础货币', ko: '기본 통화', hi: 'मूल मुद्रा', ar: 'العملة' })}
                                showClearButton={false}
                                showDropDownButton={false}
                                className={'register-sub-bus-industry'}
                                value={baseCurrency}
                                displayExpr={'name'}
                                valueExpr={'code'}
                                itemRender={(e) => {
                                    return <div className="register-sub-bus-industry-name">{e.name}</div>;
                                }}
                                onValueChanged={(e) => {
                                    setBaseCurrency(e.value);
                                }}
                            >
                                <Validator>
                                    <RequiredRule
                                        message={AntLocalization.translateText({ vi: 'Không được trống !', en: 'Cannot be empty!', fr: 'Ne peut pas être vide !', es: '¡No puede estar vacío!', id: 'Tidak boleh kosong!', ja: '空にできません！', zh: '不能为空！', ko: '비워둘 수 없습니다!', hi: 'खाली नहीं हो सकता!', ar: 'لا يمكن أن يكون فارغاً!' })}
                                    />
                                </Validator>
                                <TextBoxButton
                                    name="baseCurrency"
                                    location="before"
                                    options={{
                                        icon: 'coffee',
                                        stylingMode: 'text',
                                        focusStateEnabled: false,
                                        activeStateEnabled: false,
                                        hoverStateEnabled: false,
                                        type: 'default'
                                    }}
                                />
                            </SelectBox>
                        </div>
                        )}

                        {/* <div className={'dx-field'}>
                            <TextBox
                                ref={txtOwnerFullName}
                                value={ownerFullName}
                                placeholder={AntLocalization.translateText({ vi: 'Người đại diện', en: 'The Representative', fr: 'Le représentant', es: 'El representante', id: 'Perwakilan', ja: '代表者', zh: '代表人', ko: '대표자', hi: 'प्रतिनिधि', ar: 'الممثل' })}
                                width={'100%'}
                                className={'register-owner-fullname'}
                                maxLength={64}
                                inputAttr={{
                                    style: 'text-transform: uppercase'
                                }}
                                onValueChanged={(e) => {
                                    setOwnerFullName(String(e.value).toUpperCase().trim());
                                }}
                                onEnterKey={(e) => {
                                    if (txtOwnerPhone.current) txtOwnerPhone.current.instance.focus();
                                }}
                                onFocusIn={(e) => {
                                    let inputEl = e.element.querySelector('.dx-texteditor-input');
                                    if (inputEl) {
                                        inputEl.selectionStart = 0;
                                        inputEl.selectionEnd = inputEl.value.length;
                                    }
                                }}
                            >
                                <Validator>
                                    <RequiredRule
                                        message={AntLocalization.translateText({ vi: 'Không được trống !', en: 'Cannot be empty!', fr: 'Ne peut pas être vide !', es: '¡No puede estar vacío!', id: 'Tidak boleh kosong!', ja: '空にできません！', zh: '不能为空！', ko: '비워둘 수 없습니다!', hi: 'खाली नहीं हो सकता!', ar: 'لا يمكن أن يكون فارغاً!' })}
                                    />
                                    <StringLengthRule
                                        message={AntLocalization.translateText({ vi: 'Tối thiểu 8 ký tự', en: 'Minimum 8 characters', fr: '8 caractères minimum', es: 'Mínimo 8 caracteres', id: 'Minimal 8 karakter', ja: '最低8文字', zh: '至少8个字符', ko: '최소 8자', hi: 'न्यूनतम 8 वर्ण', ar: '8 أحرف على الأقل' })}
                                        min={8}
                                    />
                                    <StringLengthRule
                                        message={AntLocalization.translateText({ vi: 'Tối đa 64 ký tự', en: 'Maximum 64 characters', fr: '64 caractères maximum', es: 'Máximo 64 caracteres', id: 'Maksimal 64 karakter', ja: '最大64文字', zh: '最多64个字符', ko: '최대 64자', hi: 'अधिकतम 64 वर्ण', ar: '64 حرفًا كحد أقصى' })}
                                        max={64}
                                    />
                                    <PatternRule
                                        message={AntLocalization.translateText({ vi: 'Không được chứa ký tự đặc biệt !', en: 'Special characters are not allowed!', fr: 'Les caractères spéciaux ne sont pas autorisés !', es: '¡No se permiten caracteres especiales!', id: 'Karakter khusus tidak diizinkan!', ja: '特殊文字は使用できません！', zh: '不允许使用特殊字符！', ko: '특수 문자는 허용되지 않습니다!', hi: 'विशेष वर्णों की अनुमति नहीं है!', ar: 'الأحرف الخاصة غير مسموح بها!' })}
                                        pattern={'^[^\\`~!#$%^&*()=+\\[\\]{}\\|;\':",<>?/]+$'}
                                    />
                                </Validator>
                                <TextBoxButton
                                    name="ownerFullName"
                                    location="before"
                                    options={{
                                        icon: 'user',
                                        stylingMode: 'text',
                                        focusStateEnabled: false,
                                        activeStateEnabled: false,
                                        hoverStateEnabled: false,
                                        type: 'default'
                                    }}
                                />
                            </TextBox>
                        </div> */}

                        <div className={'dx-field'}>
                            <Button
                                type={'default'}
                                text={AntLocalization.translateText({ vi: 'ĐĂNG KÝ', en: 'REGISTER', fr: "S'INSCRIRE", es: 'REGISTRARSE', id: 'DAFTAR', ja: '登録', zh: '注册', ko: '가입', hi: 'पंजीकरण', ar: 'تسجيل' })}
                                disabled={!step1Processable}
                                onClick={step1Request}
                                width={'100%'}
                                style={{ fontWeight: 500 }}
                            />
                        </div>
                    </ValidationGroup>
                )}

                {currentStage === 'Step2' && (
                    <ValidationGroup ref={vGroup1_2} className={'register-panel'}>
                        {usePhoneNumber && (
                            <div className={'dx-field'}>
                                <TextBox
                                    ref={txtOwnerPhone}
                                    value={ownerPhone}
                                    placeholder={phoneExample || AntLocalization.translateText({ vi: 'Số điện thoại', en: 'Phone Number', fr: 'Numéro de téléphone', es: 'Número de teléfono', id: 'Nomor telepon', ja: '電話番号', zh: '电话号码', ko: '전화번호', hi: 'फ़ोन नंबर', ar: 'رقم الهاتف' })}
                                    width={'100%'}
                                    className={'register-owner-phone'}
                                    onValueChanged={(e) => {
                                        setOwnerPhone(e.value);
                                    }}
                                    onEnterKey={(e) => {
                                        if (txtOwnerEmail.current) txtOwnerEmail.current.instance.focus();
                                    }}
                                    // onEnterKey={step1Request}
                                    onFocusIn={(e) => {
                                        let inputEl = e.element.querySelector('.dx-texteditor-input');
                                        if (inputEl) {
                                            inputEl.selectionStart = 0;
                                            inputEl.selectionEnd = inputEl.value.length;
                                        }
                                    }}
                                    onFocusOut={() => {
                                        // Rời ô → format số theo chuẩn nước (chỉ khi hợp lệ; nước không hỗ trợ giữ nguyên)
                                        var v = String(ownerPhone || '').trim();
                                        if (v && phoneSupported) {
                                            try {
                                                var _p = parsePhoneNumberFromString(v, baseCountry);
                                                if (_p && _p.isValid()) setOwnerPhone(_p.formatNational());
                                            } catch (err) {}
                                        }
                                    }}
                                >
                                    <Validator>
                                        {/* <RequiredRule
                                        message={AntLocalization.translateText({ vi: 'Không được trống !', en: 'Cannot be empty!', fr: 'Ne peut pas être vide !', es: '¡No puede estar vacío!', id: 'Tidak boleh kosong!', ja: '空にできません！', zh: '不能为空！', ko: '비워둘 수 없습니다!', hi: 'खाली नहीं हो सकता!', ar: 'لا يمكن أن يكون فارغاً!' })}
                                    /> */}
                                        {/* <StringLengthRule
                                        message={AntLocalization.translateText({ vi: 'Tối thiểu 10 ký tự', en: 'Minimum 10 characters', fr: '10 caractères minimum', es: 'Mínimo 10 caracteres', id: 'Minimal 10 karakter', ja: '最低10文字', zh: '至少10个字符', ko: '최소 10자', hi: 'न्यूनतम 10 वर्ण', ar: '10 أحرف على الأقل' })}
                                        min={10}
                                    /> */}
                                        {/* <StringLengthRule
                                        message={AntLocalization.translateText({ vi: 'Tối đa 12 ký tự', en: 'Maximum 12 characters', fr: '12 caractères maximum', es: 'Máximo 12 caracteres', id: 'Maksimal 12 karakter', ja: '最大12文字', zh: '最多12个字符', ko: '최대 12자', hi: 'अधिकतम 12 वर्ण', ar: '12 حرفًا كحد أقصى' })}
                                        max={12}
                                    /> */}
                                        <PatternRule
                                            message={AntLocalization.translateText({ vi: 'Chỉ nhập số và ký tự điện thoại (+ - ( ) khoảng trắng)', en: 'Only digits and phone characters (+ - ( ) space) allowed', fr: 'Uniquement chiffres et caractères téléphoniques (+ - ( ) espace)', es: 'Solo dígitos y caracteres de teléfono (+ - ( ) espacio)', id: 'Hanya angka dan karakter telepon (+ - ( ) spasi)', ja: '数字と電話記号（+ - ( ) スペース）のみ', zh: '仅限数字和电话字符（+ - ( ) 空格）', ko: '숫자와 전화 기호(+ - ( ) 공백)만 입력', hi: 'केवल अंक और फ़ोन वर्ण (+ - ( ) स्पेस)', ar: 'الأرقام ورموز الهاتف فقط (+ - ( ) مسافة)' })}
                                            pattern={'^[0-9+\\-() ]*$'}
                                        />
                                        <CustomRule
                                            message={
                                                AntLocalization.translateText({ vi: 'Số điện thoại không đúng định dạng của nước đã chọn', en: 'Phone number is not valid for the selected country', fr: 'Numéro de téléphone non valide pour le pays sélectionné', es: 'Número no válido para el país seleccionado', id: 'Nomor tidak valid untuk negara yang dipilih', ja: '選択した国の電話番号形式が正しくありません', zh: '电话号码不符合所选国家/地区的格式', ko: '선택한 국가의 전화번호 형식이 올바르지 않습니다', hi: 'चयनित देश के लिए फ़ोन नंबर मान्य नहीं है', ar: 'رقم الهاتف غير صالح للدولة المختارة' }) +
                                                (phoneExample ? ' (' + AntLocalization.translateText({ vi: 'VD', en: 'e.g.', fr: 'ex.', es: 'ej.', id: 'cth', ja: '例', zh: '例', ko: '예', hi: 'उदा॰', ar: 'مثال' }) + ': ' + phoneExample + ')' : '')
                                            }
                                            validationCallback={(e) => {
                                                var v = String((e && e.value) || '').trim();
                                                if (!v) return true; // trống: bước này số điện thoại không bắt buộc
                                                if (!phoneSupported) return true; // nước không có quy chuẩn → nhập LINH ĐỘNG
                                                try {
                                                    return isValidPhoneNumber(v, baseCountry);
                                                } catch (err) {
                                                    return true;
                                                }
                                            }}
                                        />
                                    </Validator>
                                    <TextBoxButton
                                        name="ownerPhoneIcon"
                                        location="before"
                                        options={{
                                            icon: 'tel',
                                            stylingMode: 'text',
                                            focusStateEnabled: false,
                                            activeStateEnabled: false,
                                            hoverStateEnabled: false,
                                            type: 'default'
                                        }}
                                    />
                                    {phoneCode && (
                                        <TextBoxButton
                                            name="ownerPhoneCode"
                                            location="before"
                                            options={{
                                                text: phoneCode,
                                                stylingMode: 'text',
                                                focusStateEnabled: false,
                                                activeStateEnabled: false,
                                                hoverStateEnabled: false,
                                                type: 'default'
                                            }}
                                        />
                                    )}
                                </TextBox>
                            </div>
                        )}

                        <div className={'dx-field'}>
                            <TextBox
                                ref={txtOwnerEmail}
                                value={ownerEmail}
                                placeholder={'Email'}
                                width={'100%'}
                                mode="email"
                                className={'register-owner-email'}
                                maxLength={64}
                                onValueChanged={(e) => {
                                    setOwnerEmail(String(e.value).toLowerCase().trim().replace(' ', ''));
                                }}
                                onEnterKey={() => setTimeout(step2RequestWithPhoneAndEmail, 1000)}

                                // onEnterKey={(e) => {
                                //     if (txtOwnerEmail.current) txtOwnerEmail.current.instance.focus();
                                // }}
                            >
                                <Validator>
                                    <EmailRule message={'Không đúng định dạng !'} />
                                    <StringLengthRule message="Tối đa 64 ký tự" max={64} />
                                    <PatternRule message="Không được chứa ký tự đặc biệt !" pattern={'^[^\\`~!#$%^&*()=+\\[\\]{}\\|;\':",<>?/]+$'} />
                                </Validator>
                                <TextBoxButton
                                    name="ownerEmail"
                                    location="before"
                                    options={{
                                        icon: 'email',
                                        stylingMode: 'text',
                                        focusStateEnabled: false,
                                        activeStateEnabled: false,
                                        hoverStateEnabled: false,
                                        type: 'default'
                                    }}
                                />
                            </TextBox>
                        </div>
                        <div className={'dx-field'}>
                            <Button
                                type={'default'}
                                text={AntLocalization.translateText({ vi: 'XÁC NHẬN', en: 'NEXT', fr: 'SUIVANT', es: 'SIGUIENTE', id: 'LANJUT', ja: '次へ', zh: '下一步', ko: '다음', hi: 'अगला', ar: 'التالي' })}
                                disabled={!step2Processable}
                                onClick={step2RequestWithPhoneAndEmail}
                                width={'100%'}
                                style={{ fontWeight: 500 }}
                            />
                        </div>

                        <div className={'dx-field'} style={{ justifyContent: 'center', marginTop: 20, marginBottom: 20, display: 'flex' }}>
                            <GoogleLoginButton onClick={loginWithGoogle} />
                        </div>
                    </ValidationGroup>
                )}

                {currentStage === 'Step3' && (
                    <div>
                        {!message && (
                            <div className={'dx-field'}>
                                <AntDescPanel
                                    text={
                                        AntLocalization.translateText({ vi: 'Mã xác nhận đã được gửi đến số ', en: 'Verification code has been sent to number ', fr: 'Le code de vérification a été envoyé au numéro ', es: 'El código de verificación se envió al número ', id: 'Kode verifikasi telah dikirim ke nomor ', ja: '認証コードが送信されました：', zh: '验证码已发送至号码 ', ko: '인증코드가 전송되었습니다: ', hi: 'सत्यापन कोड इस नंबर पर भेजा गया: ', ar: 'تم إرسال رمز التحقق إلى الرقم ' }) + ownerPhone
                                    }
                                />
                                <AntDescPanel
                                    text={AntLocalization.translateText({ vi: 'Vui lòng kiểm tra tin nhắn và nhập lại :', en: 'Please check your message and re-enter :', fr: 'Veuillez vérifier votre message et saisir le code :', es: 'Revise su mensaje e ingrese el código :', id: 'Silakan cek pesan Anda dan masukkan kode :', ja: 'メッセージを確認してコードを入力してください：', zh: '请查看短信并输入验证码：', ko: '메시지를 확인하고 코드를 입력하세요 :', hi: 'कृपया अपना संदेश जांचें और कोड दर्ज करें :', ar: 'يرجى التحقق من رسالتك وإدخال الرمز :' })}
                                />
                            </div>
                        )}
                        {message && (
                            <div className={'dx-field'}>
                                <AntDescPanel text={message} />
                            </div>
                        )}

                        {/* 
                            {this.state.busModel === 'Company' && (
                                <div className={'dx-field'}>
                                    <AntDescPanel text={'Mã xác nhận đã được gửi đến hộp thư ' + this.state.ownerEmail} />
                                    <AntDescPanel text={'Vui lòng kiểm tra và nhập lại :'} />
                                </div>
                            )} */}

                        <div className={'dx-field'}>
                            <TextBox
                                ref={txtOwnerOTP}
                                value={ownerOTP}
                                placeholder={'OTP'}
                                width={'100%'}
                                className={'register-owner-phone-otp'}
                                mask="0 0 0 0 0 0"
                                maskRules={{ X: /[02-9]/ }}
                                maskInvalidMessage={null}
                                // validationStatus="valid"
                                valueChangeEvent="keyup"
                                onValueChanged={(e) => {
                                    setOwnerOTP(e.value);
                                    setErrorText(null);

                                    if (String(e.value).trim().length === 6) step3VerifyOTP(String(e.value).trim());
                                }}
                                onFocusIn={(e) => {
                                    let inputEl = e.element.querySelector('.dx-texteditor-input');
                                    if (inputEl) {
                                        inputEl.selectionStart = 0;
                                        inputEl.selectionEnd = inputEl.value.length;
                                    }
                                }}
                            />
                        </div>
                    </div>
                )}

                {currentStage === 'Step5' && (
                    <div className={'dx-field'} style={{ textAlign: 'center' }}>
                        <LoadIndicator className={'register-loading'} />
                    </div>
                )}
                {errorText && (
                    <div className={'dx-field'} style={{ marginLeft: '-18px' }}>
                        <AntErrorPanel text={errorText} />
                    </div>
                )}
                <div className={'dx-field'} style={{ marginTop: '10px' }}>
                    <Link to={'/login'}>
                        {AntLocalization.translateText({ vi: 'Đăng nhập tại đây.', en: 'Log in here.', fr: 'Connectez-vous ici.', es: 'Inicie sesión aquí.', id: 'Masuk di sini.', ja: 'こちらからログイン', zh: '在此登录', ko: '여기서 로그인', hi: 'यहाँ लॉगिन करें', ar: 'سجّل الدخول هنا.' })}
                    </Link>
                </div>
            </AntCardLayout>
        );

    return (
        <div>
            <LoadPanel
                visible={true}
                showPane={false}
                shading={false}
                // shadingColor={'rgba(255, 255, 255, 1)'}
                // indicatorSrc={'https://image.flaticon.com/icons/svg/3305/3305803.svg'}

                wrapperAttr={{
                    class: 'ant-loading'
                }}
            />
        </div>
    );
}
